import type { FC } from "react";
// в будущем данные будут приходить из cms
// eslint-disable-next-line boundaries/external
import { useTranslation } from "react-i18next";

import { Button } from "~/shared/ui-kit";
import { Flex } from "~/shared/ui-kit/flex/Flex";

type Props = {
  playNowLink?: string;
  burgerButton?: boolean;
  featureFlags?: {
    isCreateButtonEnabled: boolean;
  };
  loginHeader: () => void;
  createAccountHeader: () => void;
};

export const HeaderAuthButtons: FC<Props> = ({
  playNowLink,
  burgerButton,
  featureFlags,
  loginHeader,
  createAccountHeader,
}) => {
  const { t } = useTranslation("header");

  const redirectToRoom = (): void => {
    if (playNowLink) {
      window.location.href = playNowLink;
    }
  };

  if (burgerButton && featureFlags?.isCreateButtonEnabled) {
    return (
      <Button
        className="w-full h-12"
        onPress={() => {
          loginHeader();
          redirectToRoom();
        }}
        variant="transparent"
      >
        {t("auth.button.login")}
      </Button>
    );
  }

  return (
    <Flex align="center" gap={10}>
      <Button
        className="hidden md:flex h-8 md:h-12 px-3 md:px-6 text-xs md:text-base "
        variant="transparent"
        onPress={() => {
          loginHeader();
          redirectToRoom();
        }}
      >
        {t("auth.button.login")}
      </Button>

      {featureFlags?.isCreateButtonEnabled && (
        <Button
          className="h-8 md:h-12 px-3 md:px-6 text-xs md:text-base "
          onPress={() => {
            createAccountHeader();
            redirectToRoom();
          }}
        >
          {t("auth.button.create")}
        </Button>
      )}
    </Flex>
  );
};
